import {
  type VerifyDestination,
  verifyPath,
} from '../../utils/unverified-account';

/**
 * Where an account that exists but was never verified goes.
 *
 * Three doors used to dead-end on such an account: sign-in said
 * "Authentication failed.", the invite link's sign-up said "already
 * registered", and a password reset sent nothing. Every one of them now lands
 * here. The server behind each door has already asked Cognito for a fresh
 * code and says whether one went out; this only remembers the address for the
 * verify page and goes. A full navigation, not the router: the auth pages sit
 * behind next-auth's middleware and a client-side push gets intercepted.
 */
export function goToVerification(
  email: string,
  destination: VerifyDestination = {}
): void {
  if (typeof window === 'undefined') {
    return;
  }
  sessionStorage.setItem('verificationEmail', email);
  window.location.href = verifyPath(destination);
}

/** The response body, or {} when there is none or it is not JSON. */
export async function readJson(
  response: Response
): Promise<Record<string, unknown>> {
  try {
    return (await response.json()) as Record<string, unknown>;
  } catch {
    return {};
  }
}
